/**
 * Created by mykurisu on 2017/6/23.
 */
const defaults = {
    //new sharecard
    animated: false,
    transition: '',
    width: 26,
    type: '',
    id: '',
    title: null,
    is_resell: false,
    top: 10,
};

export default(state = defaults, action) => {
    switch (action.type) {
        case 'SHARECARD_INIT':
            return {...state, ...action.payload};
        case 'SHARECARD_SLIDE':
            return {...state, width: action.payload};
        case 'SHARECARD_ANIMATION':
            return {...state, animated: true};
        case 'SHARECARD_TRANSITION':
            return {...state, transition: 'width .5s'};
        case 'SHARECARD_RESET_TOP':
            return {...state, top: 10};
        case 'SHARECARD_TOP':
            return {...state, top: 50};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/sharecard.js